import { jsx as _jsx } from "preact/jsx-runtime";
import { useController, useFormContext, } from 'react-hook-form';
export default function HiddenInput(props) {
    const { inputAttrs } = props;
    const { name } = inputAttrs;
    const { control } = useFormContext();
    const { field: { value } } = useController({ name, control });
    return (_jsx("input", { type: "hidden", ...inputAttrs, value: value }));
}
